export const CASUAL_PAGE_CONFIG = {
  "title": "Realtime Overview",
  "titleCN": "实时总览",
  "subTitle": "Timezone (UTC{{timeZone}})",
  "subTitleCN": "时区 (UTC{{timeZone}})",
  "path": "/realtime/overview",
  "defaultTab": "overall",
  "tabList": [
    {
      "id": "overall",
      "tabName": "Overall",
      "tabNameCN": "总览",
      "isHaveNotification": true,
      "refresh": true,
      "notificationPath": "/realtime/overview/overall",
      "path": "/realtime/overview/overall",
      "tabIcon": "",
      "logConfig": {
        "pageId": "208301",
        "pageName": "Realtime Overview Overall",
        "extInfo": "IAA Realtime Overview Overall",
        "pagePath": "/realtime/overview/overall"
      },
      "filters": [
        {
          "name": "RealtimeRevenueFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/realtime/overview/overall",
          "selectorApi": "/api/v1/dashboard/pc/realtime/ua/selector",
          "extraSelectorParams": {
            "data_source": "dashboard"
          },
          "componentList": [
            {
              "name": "MetricInfo",
              "children": [
                {
                  "name": "MetricsCardTitle",
                  "className": "",
                  "type": "view",
                  "style": {},
                  "props": {
                    "config": {
                      "titleEn": "Realtime Key Metrics",
                      "titleCn": "实时关键指标",
                      "isMetricsExplain": false
                    }
                  }
                },
                {
                  "name": "realtimeUserService",
                  "className": "dbd-realtime-casual-metric-card-list",
                  "type": "view",
                  "style": {},
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/realtime/usertag",
                      "dataKey": "usertag",
                      "refreshKey": "realtime_user_usertag",
                      "interval": 300000,
                      "extraParams": {
                        "metrics": [
                          "active_users",
                          "new_users"
                        ]
                      }
                    }
                  },
                  "children": [
                    {
                      "name": "realtimeUserService",
                      "className": "",
                      "type": "view",
                      "style": {},
                      "props": {
                        "config": {
                          "api": "/api/v1/dashboard/realtime/retention",
                          "dataKey": "retention",
                          "refreshKey": "realtime_user_retention",
                          "interval": 300000
                        }
                      },
                      "children": [
                        {
                          "name": "realtimeUserService",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/realtime/avg_playtime_matches",
                              "dataKey": "avg_playtime_matches",
                              "refreshKey": "realtime_user_avg_playtime_matches",
                              "interval": 300000,
                              "extraParams": {
                                "user_type": "active"
                              }
                            }
                          },
                          "children": [
                            {
                              "name": "MetricCardCo",
                              "className": "dbd-retention-card",
                              "type": "view",
                              "style": {},
                              "props": {
                                "config": {}
                              },
                              "children": [
                                {
                                  "name": "CommonRow",
                                  "className": "",
                                  "type": "layout",
                                  "style": {},
                                  "props": {},
                                  "children": [
                                    {
                                      "name": "CommonCol",
                                      "className": "",
                                      "type": "layout",
                                      "style": {
                                        "width": "20%"
                                      },
                                      "props": {},
                                      "children": [
                                        {
                                          "name": "MetricsCardContext",
                                          "className": "",
                                          "type": "view",
                                          "style": {},
                                          "props": {
                                            "config": {
                                              "apiDataKey": "usertag",
                                              "dataKey": [
                                                "new_users_card"
                                              ],
                                              "isRealTime": true
                                            }
                                          },
                                          "children": [
                                            {
                                              "name": "MetricComponent",
                                              "path": "realtime/users",
                                              "componentKey": "NewUsersMetricCard",
                                              "className": "dbd-realtime-casual-metric-card",
                                              "height": 164,
                                              "config": {
                                                "props": {
                                                  "isRealTime": true,
                                                  "isPlaceholderTime": true
                                                }
                                              }
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    {
                                      "name": "CommonCol",
                                      "className": "",
                                      "type": "layout",
                                      "style": {
                                        "width": "20%"
                                      },
                                      "props": {},
                                      "children": [
                                        {
                                          "name": "MetricsCardContext",
                                          "className": "",
                                          "type": "view",
                                          "style": {},
                                          "props": {
                                            "config": {
                                              "apiDataKey": "usertag",
                                              "dataKey": [
                                                "active_users_card"
                                              ],
                                              "isRealTime": true
                                            }
                                          },
                                          "children": [
                                            {
                                              "name": "MetricComponent",
                                              "path": "realtime/users",
                                              "componentKey": "ActiveUsersMetricCard",
                                              "className": "dbd-realtime-casual-metric-card",
                                              "height": 164,
                                              "config": {
                                                "props": {
                                                  "isRealTime": true,
                                                  "isPlaceholderTime": true
                                                }
                                              }
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    {
                                      "name": "CommonCol",
                                      "className": "",
                                      "type": "layout",
                                      "style": {
                                        "width": "20%"
                                      },
                                      "props": {},
                                      "children": [
                                        {
                                          "name": "MetricsCardContext",
                                          "className": "",
                                          "type": "view",
                                          "style": {},
                                          "props": {
                                            "config": {
                                              "apiDataKey": "avg_playtime_matches",
                                              "dataKey": [
                                                "avg_playtime_card"
                                              ],
                                              "isRealTime": true
                                            }
                                          },
                                          "children": [
                                            {
                                              "name": "MetricComponent",
                                              "path": "realtime/overview",
                                              "componentKey": "AvgPlaytimeCard",
                                              "className": "dbd-realtime-casual-metric-card",
                                              "height": 164,
                                              "config": {
                                                "props": {
                                                  "isRealTime": true,
                                                  "isPlaceholderTime": true
                                                }
                                              }
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    {
                                      "name": "CommonCol",
                                      "className": "",
                                      "type": "layout",
                                      "style": {
                                        "width": "20%"
                                      },
                                      "props": {},
                                      "children": [
                                        {
                                          "name": "MetricsCardContext",
                                          "className": "",
                                          "type": "view",
                                          "style": {},
                                          "props": {
                                            "config": {
                                              "apiDataKey": "avg_playtime_matches",
                                              "dataKey": [
                                                "avg_matches_card"
                                              ],
                                              "isRealTime": true
                                            }
                                          },
                                          "children": [
                                            {
                                              "name": "MetricComponent",
                                              "path": "realtime/overview",
                                              "componentKey": "AvgMatchesCard",
                                              "className": "dbd-realtime-casual-metric-card",
                                              "height": 164,
                                              "config": {
                                                "props": {
                                                  "isRealTime": true,
                                                  "isPlaceholderTime": true
                                                }
                                              }
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    {
                                      "name": "CommonCol",
                                      "className": "",
                                      "type": "layout",
                                      "style": {
                                        "width": "20%"
                                      },
                                      "props": {},
                                      "children": [
                                        {
                                          "name": "MetricsCardContext",
                                          "className": "",
                                          "type": "view",
                                          "style": {},
                                          "props": {
                                            "config": {
                                              "apiDataKey": "retention",
                                              "dataKey": [
                                                "d2_card"
                                              ],
                                              "isRealTime": true
                                            }
                                          },
                                          "children": [
                                            {
                                              "name": "MetricComponent",
                                              "path": "realtime/users",
                                              "componentKey": "d2t1MetricCard",
                                              "className": "dbd-realtime-casual-metric-card",
                                              "height": 164,
                                              "config": {
                                                "props": {
                                                  "isRealTime": true,
                                                  "isPlaceholderTime": true
                                                }
                                              }
                                            }
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "CommonRow",
                  "className": "margin-t-10",
                  "children": [
                    {
                      "name": "CommonCol",
                      "type": "layout",
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "realtimeUserService",
                          "className": "dbd-daily-card",
                          "type": "view",
                          "data": {
                            "height": 164
                          },
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/realtime/ua/card",
                              "dataKey": "iaa_revenue",
                              "refreshKey": "realtime_iaa_revenue",
                              "interval": 300000,
                              "isByDimensionCard": true,
                              "extraParams": {
                                "metrics": [
                                  "iaa_revenue"
                                ],
                                "accumulation": {
                                  "custom_accumulation": [
                                    {
                                      "key": "ad_format",
                                      "is_accumulation": true
                                    }
                                  ]
                                }
                              }
                            }
                          },
                          "children": [
                            {
                              "name": "MetricCardCo",
                              "className": "dbd-retention-card",
                              "type": "view",
                              "style": {
                                "marginTop": "0",
                                "minHeight": "179px"
                              },
                              "props": {
                                "config": {
                                  "apiDataKey": "iaa_revenue"
                                }
                              },
                              "children": [
                                {
                                  "name": "MetricComponent",
                                  "path": "realtime/revenue",
                                  "componentKey": "IAARevenuePlatformCard",
                                  "height": 179,
                                  "config": {
                                    "props": {
                                      "dimension": "ad_format",
                                      "isRealTime": true,
                                      "hasChart": false,
                                      "config": {
                                        "dataKey": "{{iaa_revenue.data}}"
                                      },
                                      "style": {
                                        "minHeight": "179px"
                                      }
                                    }
                                  }
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "type": "layout",
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "realtimeUserService",
                          "className": "dbd-daily-card",
                          "type": "view",
                          "data": {
                            "height": 164
                          },
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/realtime/ua/card",
                              "dataKey": "ecpm",
                              "refreshKey": "realtime_ecpm",
                              "interval": 300000,
                              "isByDimensionCard": true,
                              "extraParams": {
                                "metrics": [
                                  "ecpm"
                                ],
                                "accumulation": {
                                  "custom_accumulation": [
                                    {
                                      "key": "ad_format",
                                      "is_accumulation": true
                                    }
                                  ]
                                }
                              }
                            }
                          },
                          "children": [
                            {
                              "name": "MetricCardCo",
                              "className": "dbd-retention-card",
                              "type": "view",
                              "style": {
                                "marginTop": "0",
                                "minHeight": "179px"
                              },
                              "props": {
                                "config": {
                                  "apiDataKey": "ecpm"
                                }
                              },
                              "children": [
                                {
                                  "name": "MetricComponent",
                                  "path": "realtime/revenue",
                                  "componentKey": "EcpmPlatformCard",
                                  "height": 179,
                                  "config": {
                                    "props": {
                                      "dimension": "ad_format",
                                      "hasChart": false,
                                      "isRealTime": true,
                                      "config": {
                                        "dataKey": "{{ecpm.data}}"
                                      },
                                      "style": {
                                        "minHeight": "179px"
                                      }
                                    }
                                  }
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "CommonRow",
                  "className": "margin-t-10",
                  "children": [
                    {
                      "name": "CommonCol",
                      "type": "layout",
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "realtimeUserService",
                          "className": "dbd-daily-card",
                          "type": "view",
                          "data": {
                            "height": 164
                          },
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/realtime/ua/card",
                              "dataKey": "iaa_impressions",
                              "refreshKey": "realtime_iaa_impressions",
                              "interval": 300000,
                              "isByDimensionCard": true,
                              "extraParams": {
                                "metrics": [
                                  "iaa_impressions"
                                ],
                                "accumulation": {
                                  "custom_accumulation": [
                                    {
                                      "key": "ad_format",
                                      "is_accumulation": true
                                    }
                                  ]
                                }
                              }
                            }
                          },
                          "children": [
                            {
                              "name": "MetricCardCo",
                              "className": "dbd-retention-card",
                              "type": "view",
                              "style": {
                                "marginTop": "0",
                                "minHeight": "179px"
                              },
                              "props": {
                                "config": {
                                  "apiDataKey": "iaa_impressions"
                                }
                              },
                              "children": [
                                {
                                  "name": "MetricComponent",
                                  "path": "realtime/revenue",
                                  "componentKey": "ImpressionsPlatformCard",
                                  "height": 179,
                                  "config": {
                                    "props": {
                                      "dimension": "ad_format",
                                      "hasChart": false,
                                      "isRealTime": true,
                                      "config": {
                                        "dataKey": "{{iaa_impressions.data}}"
                                      },
                                      "style": {
                                        "minHeight": "179px"
                                      }
                                    }
                                  }
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "type": "layout",
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "realtimeUserService",
                          "className": "dbd-daily-card",
                          "type": "view",
                          "data": {
                            "height": 164
                          },
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/realtime/ua/card",
                              "dataKey": "iaa_fill_rate_per",
                              "refreshKey": "realtime_iaa_fill_rate_per",
                              "interval": 300000,
                              "isByDimensionCard": true,
                              "extraParams": {
                                "metrics": [
                                  "iaa_fill_rate_per"
                                ],
                                "accumulation": {
                                  "custom_accumulation": [
                                    {
                                      "key": "ad_format",
                                      "is_accumulation": true
                                    }
                                  ]
                                }
                              }
                            }
                          },
                          "children": [
                            {
                              "name": "MetricCardCo",
                              "className": "dbd-retention-card",
                              "type": "view",
                              "style": {
                                "marginTop": "0",
                                "minHeight": "179px"
                              },
                              "props": {
                                "config": {
                                  "apiDataKey": "iaa_fill_rate_per"
                                }
                              },
                              "children": [
                                {
                                  "name": "MetricComponent",
                                  "path": "realtime/revenue",
                                  "componentKey": "FillRatePlatformCard",
                                  "height": 179,
                                  "config": {
                                    "props": {
                                      "dimension": "ad_format",
                                      "isRealTime": true,
                                      "hasChart": false,
                                      "showShare": false,
                                      "config": {
                                        "dataKey": "{{iaa_fill_rate_per.data}}"
                                      },
                                      "style": {
                                        "minHeight": "179px"
                                      }
                                    }
                                  }
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "realtimeUserService",
                  "className": "",
                  "type": "view",
                  "data": {},
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/pc/realtime/ua/funnel",
                      "dataKey": "funnel",
                      "extraParams": {
                        "logical_flag": "isOnlyGetLatestTime",
                        "user_type": "active",
                        "metrics": [
                          "iaa_requests",
                          "request_completion_rate_per",
                          "iaa_loaded",
                          "cache_succ_rate_per",
                          "iaa_opportunity_ready",
                          "ready_rate_per",
                          "iaa_impressions",
                          "show_succ_rate_per",
                          "iaa_hidden",
                          "completion_rate_per",
                          "iaa_clicks",
                          "click_rate_per"
                        ],
                        "accumulation": {
                          "custom_accumulation": [
                            {
                              "key": "ad_format",
                              "is_accumulation": true
                            }
                          ]
                        }
                      },
                      "formatParams": "function formatParams(oParams) {\n              var params = Object.assign(oParams || {});\n              params.filters = params.filters || {};\n              params.filters.custom_filters = Object.assign([], params.filters.custom_filters || []);\n              params.filters.custom_filters.push({\n                key: 'ad_format',\n                filter_list: ['interstitial', 'rewarded']\n              });\n              return params;\n            }"
                    }
                  },
                  "children": [
                    {
                      "name": "MetricCardCo",
                      "className": "",
                      "type": "view",
                      "style": {
                        "minHeight": "408px"
                      },
                      "props": {
                        "config": {
                          "apiDataKey": "funnel"
                        }
                      },
                      "children": [
                        {
                          "name": "CommonRow",
                          "className": "margin-t-10",
                          "children": [
                            {
                              "name": "CommonCol",
                              "type": "layout",
                              "props": {
                                "w": 12
                              },
                              "children": [
                                {
                                  "name": "MetricComponent",
                                  "path": "realtime/overview",
                                  "componentKey": "RealtimeFunnelCard",
                                  "config": {
                                    "props": {
                                      "titleEn": "Realtime Interstitial Funnel",
                                      "titleCn": "实时漏斗-插屏广告",
                                      "icon": "funnel-mobile",
                                      "formatData": "function(originData) {\n                                                                                var _Object_keys;\n                                                                                var data = Object.assign({}, originData);\n                                                                                var list = (data === null || data === void 0 ? void 0 : data.list) || [];\n                                                                                var metricData = (list === null || list === void 0 ? void 0 : list.find(function(item) {\n                                                                                    return (item === null || item === void 0 ? void 0 : item.ad_format) === \"interstitial\";\n                                                                                })) || {};\n                                                                                var metricCardData = (_Object_keys = Object.keys(metricData)) === null || _Object_keys === void 0 ? void 0 : _Object_keys.map(function(key) {\n                                                                                    return {\n                                                                                        metrics_name: key,\n                                                                                        value: (metricData === null || metricData === void 0 ? void 0 : metricData[key]) || \"\",\n                                                                                        dod: \"\"\n                                                                                    };\n                                                                                });\n                                                                                return metricCardData;\n                                                                            }"
                                    }
                                  }
                                }
                              ]
                            },
                            {
                              "name": "CommonCol",
                              "type": "layout",
                              "props": {
                                "w": 12
                              },
                              "children": [
                                {
                                  "name": "MetricComponent",
                                  "path": "realtime/overview",
                                  "componentKey": "RealtimeFunnelCard",
                                  "config": {
                                    "props": {
                                      "titleEn": "Realtime Reward Funnel",
                                      "titleCn": "实时漏斗-激励广告",
                                      "icon": "funnel-dollor",
                                      "formatData": "function(originData) {\n                                                                                var _Object_keys;\n                                                                                var data = Object.assign({}, originData);\n                                                                                var list = (data === null || data === void 0 ? void 0 : data.list) || [];\n                                                                                var metricData = (list === null || list === void 0 ? void 0 : list.find(function(item) {\n                                                                                    return (item === null || item === void 0 ? void 0 : item.ad_format) === \"rewarded\";\n                                                                                })) || {};\n                                                                                var metricCardData = (_Object_keys = Object.keys(metricData)) === null || _Object_keys === void 0 ? void 0 : _Object_keys.map(function(key) {\n                                                                                    return {\n                                                                                        metrics_name: key,\n                                                                                        value: (metricData === null || metricData === void 0 ? void 0 : metricData[key]) || \"\",\n                                                                                        dod: \"\"\n                                                                                    };\n                                                                                });\n                                                                                return metricCardData;\n                                                                            }"
                                    }
                                  }
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "realtimeUserService",
                  "className": "",
                  "type": "view",
                  "style": {},
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/event_analysis/realtime/date_event_list",
                      "dataKey": "date_event_list",
                      "refreshKey": "realtime_user_event",
                      "interval": 300000
                    }
                  },
                  "children": [
                    {
                      "name": "MetricComponent",
                      "path": "realtime/overview",
                      "componentKey": "RealtimeOverallActiveTrend",
                      "config": {
                        "props": {
                          "className": "margin-t-20"
                        }
                      }
                    },
                    {
                      "name": "MetricComponent",
                      "path": "realtime/overview",
                      "componentKey": "RealtimeOverallRevenueTrend",
                      "config": {
                        "props": {
                          "className": "margin-t-20"
                        }
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "id": "newUser",
      "tabName": "New User",
      "tabNameCN": "新进用户",
      "isHaveNotification": true,
      "refresh": true,
      "notificationPath": "/realtime/overview/newUser",
      "path": "/realtime/overview/newUser",
      "tabIcon": "",
      "logConfig": {
        "pageId": "208302",
        "pageName": "Realtime Overview New User",
        "extInfo": "IAA Realtime Overview New User",
        "pagePath": "/realtime/overview/newUser"
      },
      "filters": [
        {
          "name": "RealtimeRevenueFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/realtime/overview/newUser",
          "selectorApi": "/api/v1/dashboard/pc/realtime/ua/selector",
          "extraSelectorParams": {
            "data_source": "dashboard"
          },
          "componentList": [
            {
              "name": "MetricInfo",
              "children": [
                {
                  "name": "MetricsCardTitle",
                  "className": "",
                  "type": "view",
                  "style": {},
                  "props": {
                    "config": {
                      "titleEn": "Realtime Key Metrics",
                      "titleCn": "实时关键指标",
                      "isMetricsExplain": false
                    }
                  }
                },
                {
                  "name": "realtimeUserService",
                  "className": "dbd-realtime-casual-metric-card-list",
                  "type": "view",
                  "style": {},
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/realtime/usertag",
                      "dataKey": "usertag",
                      "refreshKey": "realtime_user_usertag",
                      "interval": 300000,
                      "extraParams": {
                        "metrics": [
                          "active_users",
                          "new_users"
                        ]
                      }
                    }
                  },
                  "children": [
                    {
                      "name": "realtimeUserService",
                      "className": "",
                      "type": "view",
                      "style": {},
                      "props": {
                        "config": {
                          "api": "/api/v1/dashboard/realtime/retention",
                          "dataKey": "retention",
                          "refreshKey": "realtime_user_retention",
                          "interval": 300000
                        }
                      },
                      "children": [
                        {
                          "name": "realtimeUserService",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/realtime/avg_playtime_matches",
                              "dataKey": "avg_playtime_matches",
                              "refreshKey": "realtime_user_avg_playtime_matches",
                              "interval": 300000,
                              "extraParams": {
                                "user_type": "new"
                              }
                            }
                          },
                          "children": [
                            {
                              "name": "MetricCardCo",
                              "className": "dbd-realtime-casual-metric-card",
                              "type": "view",
                              "style": {},
                              "props": {
                                "config": {}
                              },
                              "children": [
                                {
                                  "name": "CommonRow",
                                  "className": "",
                                  "type": "layout",
                                  "style": {},
                                  "props": {},
                                  "children": [
                                    {
                                      "name": "CommonCol",
                                      "className": "",
                                      "type": "layout",
                                      "style": {
                                        "width": "25%"
                                      },
                                      "props": {},
                                      "children": [
                                        {
                                          "name": "MetricsCardContext",
                                          "className": "",
                                          "type": "view",
                                          "style": {},
                                          "props": {
                                            "config": {
                                              "apiDataKey": "usertag",
                                              "dataKey": [
                                                "new_users_card"
                                              ],
                                              "isRealTime": true
                                            }
                                          },
                                          "children": [
                                            {
                                              "name": "MetricComponent",
                                              "path": "realtime/users",
                                              "componentKey": "NewUsersMetricCard",
                                              "className": "dbd-realtime-casual-metric-card",
                                              "height": 164,
                                              "config": {
                                                "props": {
                                                  "isRealTime": true,
                                                  "isPlaceholderTime": true
                                                }
                                              }
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    {
                                      "name": "CommonCol",
                                      "className": "",
                                      "type": "layout",
                                      "style": {
                                        "width": "25%"
                                      },
                                      "props": {},
                                      "children": [
                                        {
                                          "name": "MetricsCardContext",
                                          "className": "",
                                          "type": "view",
                                          "style": {},
                                          "props": {
                                            "config": {
                                              "apiDataKey": "avg_playtime_matches",
                                              "dataKey": [
                                                "avg_playtime_card"
                                              ],
                                              "isRealTime": true
                                            }
                                          },
                                          "children": [
                                            {
                                              "name": "MetricComponent",
                                              "path": "realtime/overview",
                                              "componentKey": "AvgPlaytimeNewCard",
                                              "className": "dbd-realtime-casual-metric-card",
                                              "height": 164,
                                              "config": {
                                                "props": {
                                                  "isRealTime": true,
                                                  "isPlaceholderTime": true
                                                }
                                              }
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    {
                                      "name": "CommonCol",
                                      "className": "",
                                      "type": "layout",
                                      "style": {
                                        "width": "25%"
                                      },
                                      "props": {},
                                      "children": [
                                        {
                                          "name": "MetricsCardContext",
                                          "className": "",
                                          "type": "view",
                                          "style": {},
                                          "props": {
                                            "config": {
                                              "apiDataKey": "avg_playtime_matches",
                                              "dataKey": [
                                                "avg_matches_card"
                                              ],
                                              "isRealTime": true
                                            }
                                          },
                                          "children": [
                                            {
                                              "name": "MetricComponent",
                                              "path": "realtime/overview",
                                              "componentKey": "AvgMatchesNewCard",
                                              "className": "dbd-realtime-casual-metric-card",
                                              "height": 164,
                                              "config": {
                                                "props": {
                                                  "isRealTime": true,
                                                  "isPlaceholderTime": true
                                                }
                                              }
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    {
                                      "name": "CommonCol",
                                      "className": "",
                                      "type": "layout",
                                      "style": {
                                        "width": "25%"
                                      },
                                      "props": {},
                                      "children": [
                                        {
                                          "name": "MetricsCardContext",
                                          "className": "",
                                          "type": "view",
                                          "style": {},
                                          "props": {
                                            "config": {
                                              "apiDataKey": "retention",
                                              "dataKey": [
                                                "d2_card"
                                              ],
                                              "isRealTime": true
                                            }
                                          },
                                          "children": [
                                            {
                                              "name": "MetricComponent",
                                              "path": "realtime/users",
                                              "componentKey": "d2t1MetricCard",
                                              "className": "dbd-realtime-casual-metric-card",
                                              "height": 164,
                                              "config": {
                                                "props": {
                                                  "isRealTime": true,
                                                  "isPlaceholderTime": true
                                                }
                                              }
                                            }
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "CommonRow",
                  "className": "dbd-card-no-margin-left margin-t-10",
                  "children": [
                    {
                      "name": "CommonCol",
                      "type": "layout",
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "realtimeUserService",
                          "className": "dbd-daily-card",
                          "type": "view",
                          "data": {
                            "height": 164
                          },
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/realtime/ua/card",
                              "dataKey": "d1_cohort_revenue",
                              "refreshKey": "realtime_d1_cohort_revenue",
                              "interval": 300000,
                              "isByDimensionCard": true,
                              "extraParams": {
                                "metrics": [
                                  "d1_cohort_revenue"
                                ],
                                "accumulation": {
                                  "custom_accumulation": [
                                    {
                                      "key": "ad_format",
                                      "is_accumulation": true
                                    }
                                  ]
                                }
                              }
                            }
                          },
                          "children": [
                            {
                              "name": "MetricCardCo",
                              "className": "dbd-retention-card",
                              "type": "view",
                              "style": {
                                "marginTop": "0",
                                "minHeight": "179px"
                              },
                              "props": {
                                "config": {
                                  "apiDataKey": "d1_cohort_revenue"
                                }
                              },
                              "children": [
                                {
                                  "name": "MetricComponent",
                                  "path": "realtime/overview",
                                  "componentKey": "IAAD1CohortRevenuePlatformCard",
                                  "height": 179,
                                  "config": {
                                    "props": {
                                      "dimension": "ad_format",
                                      "isRealTime": true,
                                      "hasChart": false,
                                      "config": {
                                        "dataKey": "{{d1_cohort_revenue.data}}"
                                      },
                                      "style": {
                                        "minHeight": "179px"
                                      }
                                    }
                                  }
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "type": "layout",
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "realtimeUserService",
                          "className": "dbd-daily-card",
                          "type": "view",
                          "data": {
                            "height": 164
                          },
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/realtime/ua/card",
                              "dataKey": "d1_ecpm",
                              "refreshKey": "realtime_d1_ecpm",
                              "interval": 300000,
                              "isByDimensionCard": true,
                              "extraParams": {
                                "metrics": [
                                  "d1_ecpm"
                                ],
                                "accumulation": {
                                  "custom_accumulation": [
                                    {
                                      "key": "ad_format",
                                      "is_accumulation": true
                                    }
                                  ]
                                }
                              }
                            }
                          },
                          "children": [
                            {
                              "name": "MetricCardCo",
                              "className": "dbd-retention-card",
                              "type": "view",
                              "style": {
                                "marginTop": "0",
                                "minHeight": "179px"
                              },
                              "props": {
                                "config": {
                                  "apiDataKey": "d1_ecpm"
                                }
                              },
                              "children": [
                                {
                                  "name": "MetricComponent",
                                  "path": "realtime/overview",
                                  "componentKey": "EcpmPlatformCard",
                                  "height": 179,
                                  "config": {
                                    "props": {
                                      "dimension": "ad_format",
                                      "hasChart": false,
                                      "isRealTime": true,
                                      "config": {
                                        "dataKey": "{{d1_ecpm.data}}"
                                      },
                                      "style": {
                                        "minHeight": "179px"
                                      }
                                    }
                                  }
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "type": "layout",
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "realtimeUserService",
                          "className": "dbd-daily-card",
                          "type": "view",
                          "data": {
                            "height": 164
                          },
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/realtime/ua/card",
                              "dataKey": "d1_iaa_impressions",
                              "refreshKey": "realtime_d1_iaa_impressions",
                              "interval": 300000,
                              "isByDimensionCard": true,
                              "extraParams": {
                                "metrics": [
                                  "d1_iaa_impressions"
                                ],
                                "accumulation": {
                                  "custom_accumulation": [
                                    {
                                      "key": "ad_format",
                                      "is_accumulation": true
                                    }
                                  ]
                                }
                              }
                            }
                          },
                          "children": [
                            {
                              "name": "MetricCardCo",
                              "className": "dbd-retention-card",
                              "type": "view",
                              "style": {
                                "marginTop": "0",
                                "minHeight": "179px"
                              },
                              "props": {
                                "config": {
                                  "apiDataKey": "d1_iaa_impressions"
                                }
                              },
                              "children": [
                                {
                                  "name": "MetricComponent",
                                  "path": "realtime/overview",
                                  "componentKey": "ImpressionsPlatformCard",
                                  "height": 179,
                                  "config": {
                                    "props": {
                                      "dimension": "ad_format",
                                      "hasChart": false,
                                      "isRealTime": true,
                                      "config": {
                                        "dataKey": "{{d1_iaa_impressions.data}}"
                                      },
                                      "style": {
                                        "minHeight": "179px"
                                      }
                                    }
                                  }
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "realtimeUserService",
                  "className": "",
                  "type": "view",
                  "data": {},
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/pc/realtime/ua/funnel",
                      "dataKey": "funnel",
                      "extraParams": {
                        "logical_flag": "isOnlyGetLatestTime",
                        "user_type": "new",
                        "metrics": [
                          "d1_iaa_requests",
                          "d1_request_completion_rate_per",
                          "d1_iaa_loaded",
                          "d1_cache_succ_rate_per",
                          "d1_iaa_opportunity_ready",
                          "d1_ready_rate_per",
                          "d1_iaa_impressions",
                          "d1_show_succ_rate_per",
                          "d1_iaa_hidden",
                          "d1_completion_rate_per",
                          "d1_iaa_clicks",
                          "d1_click_rate_per"
                        ],
                        "accumulation": {
                          "custom_accumulation": [
                            {
                              "key": "ad_format",
                              "is_accumulation": true
                            }
                          ]
                        }
                      },
                      "formatParams": "function formatParams(oParams) {\n              var params = Object.assign(oParams || {});\n              params.filters = params.filters || {};\n              params.filters.custom_filters = Object.assign([], params.filters.custom_filters || []);\n              params.filters.custom_filters.push({\n                key: 'ad_format',\n                filter_list: ['interstitial', 'rewarded']\n              });\n              return params;\n            }"
                    }
                  },
                  "children": [
                    {
                      "name": "MetricCardCo",
                      "className": "",
                      "type": "view",
                      "style": {
                        "minHeight": "408px"
                      },
                      "props": {
                        "config": {
                          "apiDataKey": "funnel"
                        }
                      },
                      "children": [
                        {
                          "name": "CommonRow",
                          "className": "margin-t-10",
                          "children": [
                            {
                              "name": "CommonCol",
                              "type": "layout",
                              "props": {
                                "w": 12
                              },
                              "children": [
                                {
                                  "name": "MetricComponent",
                                  "path": "realtime/overview",
                                  "componentKey": "NewRealtimeFunnelCard",
                                  "config": {
                                    "props": {
                                      "titleEn": "Realtime Interstitial Funnel",
                                      "titleCn": "实时漏斗-插屏广告",
                                      "icon": "funnel-mobile",
                                      "formatData": "function(originData) {\n                                                                                var _Object_keys;\n                                                                                var data = Object.assign({}, originData);\n                                                                                var list = (data === null || data === void 0 ? void 0 : data.list) || [];\n                                                                                var metricData = (list === null || list === void 0 ? void 0 : list.find(function(item) {\n                                                                                    return (item === null || item === void 0 ? void 0 : item.ad_format) === \"interstitial\";\n                                                                                })) || {};\n                                                                                var metricCardData = (_Object_keys = Object.keys(metricData)) === null || _Object_keys === void 0 ? void 0 : _Object_keys.map(function(key) {\n                                                                                    return {\n                                                                                        metrics_name: key,\n                                                                                        value: (metricData === null || metricData === void 0 ? void 0 : metricData[key]) || \"\",\n                                                                                        dod: \"\"\n                                                                                    };\n                                                                                });\n                                                                                return metricCardData;\n                                                                            }"
                                    }
                                  }
                                }
                              ]
                            },
                            {
                              "name": "CommonCol",
                              "type": "layout",
                              "props": {
                                "w": 12
                              },
                              "children": [
                                {
                                  "name": "MetricComponent",
                                  "path": "realtime/overview",
                                  "componentKey": "NewRealtimeFunnelCard",
                                  "config": {
                                    "props": {
                                      "titleEn": "Realtime Reward Funnel",
                                      "titleCn": "实时漏斗-激励广告",
                                      "icon": "funnel-dollor",
                                      "formatData": "function(originData) {\n                                                                                var _Object_keys;\n                                                                                var data = Object.assign({}, originData);\n                                                                                var list = (data === null || data === void 0 ? void 0 : data.list) || [];\n                                                                                var metricData = (list === null || list === void 0 ? void 0 : list.find(function(item) {\n                                                                                    return (item === null || item === void 0 ? void 0 : item.ad_format) === \"rewarded\";\n                                                                                })) || {};\n                                                                                var metricCardData = (_Object_keys = Object.keys(metricData)) === null || _Object_keys === void 0 ? void 0 : _Object_keys.map(function(key) {\n                                                                                    return {\n                                                                                        metrics_name: key,\n                                                                                        value: (metricData === null || metricData === void 0 ? void 0 : metricData[key]) || \"\",\n                                                                                        dod: \"\"\n                                                                                    };\n                                                                                });\n                                                                                return metricCardData;\n                                                                            }"
                                    }
                                  }
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "realtimeUserService",
                  "className": "",
                  "type": "view",
                  "style": {},
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/event_analysis/realtime/date_event_list",
                      "dataKey": "date_event_list",
                      "refreshKey": "realtime_user_event",
                      "interval": 300000
                    }
                  },
                  "children": [
                    {
                      "name": "MetricComponent",
                      "path": "realtime/overview",
                      "componentKey": "RealtimeNewActiveTrend",
                      "config": {
                        "props": {
                          "className": "margin-t-20"
                        }
                      }
                    },
                    {
                      "name": "MetricComponent",
                      "path": "realtime/overview",
                      "componentKey": "RealtimeNewRevenueTrend",
                      "config": {
                        "props": {
                          "className": "margin-t-20"
                        }
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};